import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { searchFormStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchForm";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

searchFormStyles.wrapper = mergeToNew(searchFormStyles.wrapper, {
    css: css`
        background: ${themeBackgrounds.white};
        padding: 16px 8px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        padding: 24px 16px;
                    `,
                ],
                "min",
            )}
    `,
});

searchFormStyles.headingText = mergeToNew(searchFormStyles.headingText, {
    css: css`
        margin-bottom: 0;
        padding: 0 10px;
        ${({ theme }: { theme: BaseTheme }) =>
        breakpointMediaQueries(
            theme,
            [
                null,
                null,
                css`
                    margin-bottom: 0.5rem;
                `,
            ],
            "min",
        )}
    `,
});
